import common from './common';

const homeDomain = 'customer.staging.xfinity.com';
const mobileDomain = 'mcx-staging.dss-ops.xfinity.com/mobile';
const paymentDomain = 'payments.staging.xfinity.com';

const CONFIG = {
  ...common,
  homeDomain,
  mobileDomain,
  billServicesUrl: `https://${homeDomain}/billing/services`,
  billingMobileUrl: `https://${homeDomain}/billing/mobile`,
  billingMobileTransactionsUrl: `https://${homeDomain}/billing/mobile/transactions`,
  billingUrl: `https://${homeDomain}/#/billing`,
  makePaymentUrl: `https://${paymentDomain}/new`,
  cwaRoot: 'https://staging-static.cimcontent.net/common-web-assets/',
  paymentSetup: {
    ...common.paymentSetup,
    // Where to go if no continueUrl specified (from consent flow)
    defaultContinue: `https://${homeDomain}/`,
  },
  featureFlagEndpoint: 'https://sdx.qa.xfinity.com/cms/data/myAccount/web/staging/featureFlagsStaging.json',
  shelbyCMSUrl: 'https://sdx.qa.xfinity.com/cms/data/',
  xaUrl: 'https://www.stg.xfinity.com/xfinityassistant',
  collectionsBack: 'https://www.stg.xfinity.com/buy/plan/xap',
  oauthUrl: 'https://oauth-st.xfinity.com',
  nowMobileUrl: `https://${mobileDomain}/my-account/now/activity`,
  xmMyAccountUrl: `https://${mobileDomain}/my-account`,
  devicesMobileUrl: `https://${mobileDomain}/my-account/devices`,
  cimaClientId: 'my-account-web-preprod',
  cottonClientId: 'dss-mw-pci-staging',
  firebaseEnabled: false,
  firebaseConfig: {
    ...common.firebaseConfig,
    appId: '1:583702985741:web:24346f27296629d107a944',
    measurementId: 'G-382VXCRBXV',
  },
};

export default CONFIG;
